import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=38cc509c&scoped=true"
import script from "./CarList.vue?vue&type=script&lang=js"
export * from "./CarList.vue?vue&type=script&lang=js"
import style0 from "./CarList.vue?vue&type=style&index=0&id=38cc509c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc509c",
  null
  
)

export default component.exports